<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add"
      >新增</a-button>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="downloadAllQrcodes"
      >批量下载小程序二维码</a-button>

      <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="downloadAllQrcodesSquare"
      >批量下载普通二维码</a-button>


    <a-modal v-model="visible" centered title="添加机台" @ok="handleOk">
      <p>机台名称</p>
      <a-input v-model="form.deviceName" placeholder="请输入不大于5位数机台名称"></a-input>
      <p>机台编号</p>
      <a-input v-model="form.deviceNo" placeholder="请输入6位数机台编号" ></a-input>
    </a-modal>
    <a-modal v-model="visibletwo" centered title="编辑机台" @ok="handleOktwo">
      <p>机台名称</p>
      <a-input v-model="forms.deviceName" placeholder="请输入不大于5位数机台名称"></a-input>
      <p>机台编号</p>
      <a-input v-model="forms.deviceNo" placeholder="请输入6位数机台编号" ></a-input>

    </a-modal>
    <a-modal
      v-model="ifImg"
      title="机台二维码"
      @ok="handleQC(operate)"
      cancelText="取消"
      okText="确定"
    >
      <div>
        <el-button @click="downloadCodeImg()">点击下载二维码</el-button>
      </div>
      <img
        :src="img"
        style="width: 200px; height: 200px; margin-left: 100px"
        alt="机台二维码"
        @error="handleImgError"
        v-show="img"
      />
      <div v-if="!img" style="text-align: center; padding: 100px 0;">
        <a-spin tip="加载中..." />
      </div>
    </a-modal>
    
    <a-table
      :columns="columns"
      :row-key="record => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" v-on:click.prevent="showImg(operate)">
          小程序二维码
        </a>
        <a href="javascript:;" v-on:click.prevent="showImgSquare(operate)">
          普通二维码
        </a>
        <a href="javascript:;" @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  storeGetMachineList,
  storeAddMachine,
  storeEditMachine,
  storeDelMachine,
  getDeviceImg,
  getDeviceImgSquare
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "ID",
    dataIndex: "objId",
    align: "center",
    scopedSlots: { customRender: "objId" }
  },
  {
    title: "机台名称",
    dataIndex: "deviceName",
    align: "center",
    scopedSlots: { customRender: "deviceName" }
  },
  {
    title: "机台编号",
    dataIndex: "deviceNo",
    align: "center",
    scopedSlots: { customRender: "deviceNo" }
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    align: "center",
    scopedSlots: { customRender: "createTime" }
  },
  {
    title: "修改时间",
    dataIndex: "updateTime",
    align: "center",
    scopedSlots: { customRender: "updateTime" }
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" }
  }
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      loading: false,
      columns,
      img: "",
      ifImg: false,
      currentDevice: null,
      visible: false,
      visibletwo: false,
      form: {
        deviceName: "",
        deviceNo: "",
      },
      forms: {
        objId: "",
        deviceName: "",
        deviceNo: "",
      }
    };
  },
  mounted() {
    this.getData();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current;
      const data ={
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
       //重置当前页
      storeGetMachineList(data).then(res => {
        this.data = res.data;
        this.pagination.total = res.count;
        this.loading = false;
      });
    },
    edit(row) {
      this.visibletwo = true;
      this.forms.objId = row.objId;
      this.forms.deviceName = row.deviceName;
      this.forms.deviceNo = row.deviceNo;

    },
    handleQC(e) {
      this.ifImg = false;
    },
    showImg(row) {
      console.log("showImg:", row);
      this.ifImg = true;
      // 保存当前设备信息用于下载时命名
      this.currentDevice = {
        deviceName: row.deviceName,
        deviceNo: row.deviceNo
      };
      getDeviceImg(row.deviceNo).then(res => {
        console.log("showImg res ------", res);
        // 确保数据正确赋值，处理可能的多种返回格式
        if (res && res.data) {
          this.img = res.data;
        } else {
          this.img = '';
          message.error('获取二维码失败');
        }
        console.log("图片 URL:", this.img);
      }).catch(err => {
        console.error("获取二维码错误:", err);
        message.error('获取二维码失败，请重试');
      });
    },

    showImgSquare(row) {
      console.log("showImg2:", row);
      this.ifImg = true;
      // 保存当前设备信息用于下载时命名
      this.currentDevice = {
        deviceName: row.deviceName,
        deviceNo: row.deviceNo
      };
      getDeviceImgSquare(row.deviceNo).then(res => {
        console.log("showImg2 res ------", res);
        // 确保数据正确赋值，处理可能的多种返回格式
        if (res && res.data) {
          this.img = res.data;
        } else {
          this.img = '';
          message.error('获取二维码失败');
        }
        console.log("图片 URL:", this.img);
      }).catch(err => {
        console.error("获取二维码错误:", err);
        message.error('获取二维码失败，请重试');
      });
    },

    handleImgError() {
      console.error('图片加载失败:', this.img);
      // message.error('二维码图片加载失败，可能是网络问题或图片地址无效');
    },
       // 下载图片
    downloadCodeImg() {
      console.log("下载图片");
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = this.img;
      a.click();
    },

    // 查询
    query() {
      const data ={
        deviceName: this.formInline.deviceName,
        deviceNo: this.formInline.deviceNo,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.loading = true;
      storeGetMachineList(data).then(res => {
        if(res.data == null){
            message.warning("没有数据");
            this.data = [];
            this.pagination.total = 0;
            this.loading = false;
            return;
        }
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    del(row) {
      this.loading = true;
      storeDelMachine(row.objId).then(res => {
        this.loading = false;
        this.pagination.current = 1;
        this.getData();
        message.success(res.info);
      });
    },
    add() {
      this.visible = true;
      // 重新初始化表单，确保类型正确
      this.form = {
        deviceNo: "",
        deviceName: "",
        
      };
    },
    handleOk() {
      if (!this.form.deviceName) {
        message.warning("机台名称不能为空");
        return;
      }
      if (!this.form.deviceNo) {
        message.warning("机台编号不能为空");
        return;
      }
      // 分别验证两个字段
      if (this.form.deviceName.length > 5) {
        message.warning("机台名称长度不能超过5位");
        return;
      }

      if (this.form.deviceNo.length !== 6) {
        message.warning("机台编号长度必须为6位");
        return;
      }
      // 创建新的表单对象，确保使用正确的数据类型
      const submitForm = {
        deviceName: this.form.deviceName,
        deviceNo: this.form.deviceNo,
      };
      
      this.visible = false;
      console.log("submit form data:", submitForm);
      storeAddMachine(submitForm).then(res => {
        message.success(res.info);
        this.getData();
         this.form = {
                deviceName: "",
                deviceNo: "",
            };
        console.log("form:", this.form);
      });
    },
    handleOktwo() {
      if (!this.forms.deviceName) {
        message.warning("机台名称不能为空");
        return;
      }
      if (!this.forms.deviceNo) {
        message.warning("机台编号不能为空");
        return;
      }
      // 分别验证两个字段
      if (this.forms.deviceName.length > 5) {
        message.warning("机台名称长度不能超过5位");
        return;
      }

      if (this.forms.deviceNo.length !== 6) {
        message.warning("机台编号长度必须为6位");
        return;
      }
 
      // 创建新的表单对象，确保使用正确的数据类型
      const submitForms = {
        objId: this.forms.objId,
        deviceName: this.forms.deviceName.trim(),
        deviceNo: this.forms.deviceNo.trim(),
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      console.log("update submit forms:", submitForms);
      
      this.visibletwo = false;
      storeEditMachine(submitForms).then(res => {
        message.success(res.info);
        this.getData();
      });
    },
    getData() {
      const data ={
        deviceName: this.formInline.deviceName,
        deviceNo: this.formInline.deviceNo,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }

      storeGetMachineList(data).then(res => {
        // console.log("getData res ------", res);
        if(res.data.length === 0){
            message.warning("没有数据");
            this.data = [];
            this.pagination.total = 0;
            this.loading = false;
            return;
        }
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },

    async downloadAllQrcodes(){
      message.loading('正在获取设备数据...', 0);
      
      try {
        // 直接获取 300 条数据（足够覆盖所有设备）
        const allDevicesData = await storeGetMachineList({
          deviceName: this.formInline.deviceName,
          deviceNo: this.formInline.deviceNo,
          pageNo: 1,
          pageSize: 300
        });
        
        const allDevices = allDevicesData.data || [];
        
        if (!allDevices || allDevices.length === 0) {
          message.warning('没有设备数据');
          return;
        }
        
        message.destroy(); // 关闭加载提示
        message.info(`共获取到 ${allDevices.length} 个设备，开始批量下载...`);
        
        // 批量下载所有二维码
        let successCount = 0;
        
        for (let i = 0; i < allDevices.length; i++){
          let item = allDevices[i];
          
          try {
            // 显示当前下载进度
            message.loading(`正在下载第 ${i + 1}/${allDevices.length} 个二维码...`, 0);

            // 获取二维码图片 URL
            const imgUrl = await getDeviceImg(item.deviceNo).then(res => res.data);
            
            if (imgUrl) {
              // 创建 a 标签触发下载
              const a = document.createElement('a');
              a.href = imgUrl;
              a.download = `${item.deviceName}_${item.deviceNo}.png`; // 使用设备名称和编号作为文件名
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              
              successCount++;
              
              // 短暂延迟避免浏览器拦截
              await new Promise(resolve => setTimeout(resolve, 300));
            }
          } catch (error) {
            console.error(`第 ${i + 1} 个二维码获取失败:`, error);
          }
        }
        
        message.destroy(); // 关闭进度提示
        message.success(`已批量下载 ${successCount}/${allDevices.length} 个二维码到默认下载文件夹`);
        
      } catch (error) {
        message.destroy();
        console.error('批量下载失败:', error);
        message.error('批量下载失败，请重试');
      }
    },

    async downloadAllQrcodesSquare(){
      message.loading('正在获取设备数据...', 0);
      
      try {
        // 直接获取 300 条数据（足够覆盖所有设备）
        const allDevicesData = await storeGetMachineList({
          deviceName: this.formInline.deviceName,
          deviceNo: this.formInline.deviceNo,
          pageNo: 1,
          pageSize: 300
        });
        
        const allDevices = allDevicesData.data || [];
        
        if (!allDevices || allDevices.length === 0) {
          message.warning('没有设备数据');
          return;
        }
        
        message.destroy(); // 关闭加载提示
        message.info(`共获取到 ${allDevices.length} 个设备，开始批量下载...`);
        
        // 批量下载所有二维码
        let successCount = 0;
        
        for (let i = 0; i < allDevices.length; i++){
          let item = allDevices[i];
          
          try {
            // 显示当前下载进度
            message.loading(`正在下载第 ${i + 1}/${allDevices.length} 个二维码...`, 0);

            // 获取二维码图片 URL
            const imgUrl = await getDeviceImgSquare(item.deviceNo).then(res => res.data);
            
            if (imgUrl) {
              // 创建 a 标签触发下载
              const a = document.createElement('a');
              a.href = imgUrl;
              a.download = `${item.deviceName}_${item.deviceNo}.png`; // 使用设备名称和编号作为文件名
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              
              successCount++;
              
              // 短暂延迟避免浏览器拦截
              await new Promise(resolve => setTimeout(resolve, 300));
            }
          } catch (error) {
            console.error(`第 ${i + 1} 个二维码获取失败:`, error);
          }
        }
        
        message.destroy(); // 关闭进度提示
        message.success(`已批量下载 ${successCount}/${allDevices.length} 个二维码到默认下载文件夹`);
        
      } catch (error) {
        message.destroy();
        console.error('批量下载失败:', error);
        message.error('批量下载失败，请重试');
      }
    }

  }
};
</script>
<style scoped>
img {
  width: 110px;
  height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/views/storeManagement/deviceManagement/deviceContent.vue